import { useSearchParams } from '@shared/hooks/useSearchParams.hook';
import { AUTO_EDIT_QUERY_PARAM, AUTO_EDIT_QUERY_VALUE } from '@modules/items/constants';

// A page's edit mode lives in the editor's URL parameters: `view=edit` now, or `autoEdit` for the next document.
const useEmbeddedEditMode = () => {
  const { searchParams } = useSearchParams();
  const autoEdit = searchParams.get(AUTO_EDIT_QUERY_PARAM) === AUTO_EDIT_QUERY_VALUE;
  return { autoEdit, isEditMode: autoEdit || searchParams.get('view') === 'edit' };
};

export default useEmbeddedEditMode;
